import { render } from "./SidebarFooter.vue?vue&type=template&id=5549af33&ts=true"
import script from "./SidebarFooter.vue?vue&type=script&lang=ts"
export * from "./SidebarFooter.vue?vue&type=script&lang=ts"

import exportComponent from "/home/gitlab-deployer/builds/Bp7u02vYG/0/erp/admissibles-front/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__